import { Box as Flex, Typography as Text } from '@material-ui/core';

import { extractLastNameComponent } from '@spotify/confidence-core-react';
import { isType, useMetricQuery } from '@spotify/confidence-graphql';
import { useSetResolvedTitle } from '@spotify/plugin-confidence-projects-react';

import { PreviewShell } from './components';

interface MetricArtifactPreviewProps {
  resourceName: string;
}

export const MetricArtifactPreview = ({
  resourceName,
}: MetricArtifactPreviewProps) => {
  const { data, loading, error } = useMetricQuery({
    variables: { name: resourceName },
  });

  const metric = isType(data?.metric, 'MetricsV1Metric')
    ? data.metric
    : undefined;
  const entity = isType(metric?.entity, 'MetricsV1Entity')
    ? metric.entity
    : undefined;
  const previewError = error ?? (!loading && !metric ? 'not-found' : undefined);

  useSetResolvedTitle(
    metric?.displayName || extractLastNameComponent(resourceName),
  );

  return (
    <PreviewShell loading={loading} error={previewError}>
      {metric && (
        <Flex
          display="flex"
          flexDirection="column"
          style={{
            gap: 'var(--bui-space-2)',
          }}
        >
          <Flex
            display="flex"
            flexDirection="column"
            style={{
              gap: 'var(--bui-space-1)',
            }}
          >
            <Text
              variant="body1"
              style={{
                fontWeight: 'bold',
              }}
            >
              {metric.displayName || metric.name}
            </Text>
            {entity && (
              <Text variant="body2" color="textSecondary">
                {entity.displayName || entity.name}
              </Text>
            )}
          </Flex>
          {metric.description && (
            <Text variant="body2">{metric.description}</Text>
          )}
        </Flex>
      )}
    </PreviewShell>
  );
};
